/* unplugin-vue-components disabled */import script from "./PBPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PBPopup.vue?vue&type=script&setup=true&lang=js"

import "./PBPopup.vue?vue&type=style&index=0&id=d2013a60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2013a60"]])

export default __exports__